import useTranslation from '../../../../../modules/i18n/useTranslation'
import { HOME_FAQ_LIST } from '../../../data/home.data'
import FaqListItem from './FaqListItem'

const FaqList: React.FC = () => {
  const { locale } = useTranslation()
  return (
    <div className="w-full divide-y border-[#EBEBF0]">
      {HOME_FAQ_LIST(locale)
        .filter((faq) => !faq.none)
        .map((faq) => (
          <FaqListItem key={faq.id} faq={faq} />
        ))}
    </div>
  )
}

export default FaqList
